'use client'

export default function CookiePolicyPage() {
  return (
    <div className="container max-w-4xl mx-auto px-4 py-16">
      <h1 className="text-4xl font-bold mb-8">Cookie Policy</h1>
      <div className="prose prose-gray dark:prose-invert max-w-none">
        <p className="text-lg mb-8">
          Last updated: April 26, 2025
        </p>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">1. What Are Cookies</h2>
          <p>
            Cookies are small text files that are placed on your computer or mobile device when you
            visit our website. They are widely used to make websites work more efficiently and provide
            useful information to website owners.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">2. How We Use Cookies</h2>
          <p className="mb-4">We use cookies for the following purposes:</p>
          <ul className="list-disc pl-6">
            <li>To enable certain functions of the Service</li>
            <li>To provide analytics</li>
            <li>To store your preferences</li>
            <li>To enable advertisements delivery</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">3. Types of Cookies We Use</h2>
          
          <h3 className="text-xl font-semibold mb-3">3.1 Essential Cookies</h3>
          <p className="mb-4">
            These cookies are necessary for the website to function properly. They enable core
            functionality such as security, network management, and accessibility.
          </p>

          <h3 className="text-xl font-semibold mb-3">3.2 Analytics Cookies</h3>
          <p className="mb-4">
            These cookies help us understand how visitors interact with our website by collecting
            and reporting information anonymously.
          </p>

          <h3 className="text-xl font-semibold mb-3">3.3 Functional Cookies</h3>
          <p className="mb-4">
            These cookies enable enhanced functionality and personalization, such as remembering
            your preferences and settings.
          </p>

          <h3 className="text-xl font-semibold mb-3">3.4 Marketing Cookies</h3>
          <p className="mb-4">
            These cookies track your online activity to help advertisers deliver more relevant
            advertising or to limit how many times you see an advertisement.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">4. Third-Party Cookies</h2>
          <p>
            In addition to our own cookies, we may also use various third-party cookies to report
            usage statistics of the Service and deliver advertisements on and through the Service.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">5. Managing Your Cookie Preferences</h2>
          <p className="mb-4">
You have several options for managing your cookie preferences:
          </p>
          <ul className="list-disc pl-6 space-y-2">
            <li>
              <strong>Browser Settings:</strong> Most web browsers allow you to control cookies through their settings. You can typically find these options in the 'Options' or 'Preferences' menu of your browser. You can set your browser to block all cookies, accept only certain cookies, or notify you when a cookie is sent. Deleting cookies stored by your browser will remove existing cookies.
              {/* Optional: Add links to browser guides */}
              {/* 
              Find out how to manage cookies on popular browsers:
              <a href="link-to-chrome-guide" target="_blank" rel="noopener noreferrer">Google Chrome</a> | 
              <a href="link-to-firefox-guide" target="_blank" rel="noopener noreferrer">Mozilla Firefox</a> | 
              <a href="link-to-safari-guide" target="_blank" rel="noopener noreferrer">Apple Safari</a> | 
              <a href="link-to-edge-guide" target="_blank" rel="noopener noreferrer">Microsoft Edge</a>
              */}
            </li>
            <li>
              <strong>Cookie Consent Tool:</strong> When you first visit our site, or by accessing the settings via our consent banner/link (if applicable), you can choose which categories of non-essential cookies you consent to.
            </li>
            <li>
              <strong>Third-Party Opt-Outs:</strong> For some third-party analytics and advertising cookies, you may be able to opt out directly via industry opt-out programs like the NAI or DAA.
            </li>
          </ul>
          <p className="mt-4">
            Please note that disabling or deleting cookies may impact your experience on our website, and some features may not function as intended.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">6. Cookie Consent</h2>
          <p>
            When you first visit our website, we will ask for your consent to use cookies. You
            can choose to accept or decline cookies. You can also change your cookie preferences
            at any time.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">7. Updates to This Policy</h2>
          <p>
            We may update this Cookie Policy from time to time. We will notify you of any changes
            by posting the new Cookie Policy on this page.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">8. Contact Us</h2>
          <p>
            If you have any questions about this Cookie Policy, please contact us at:{' '}
            <a href="mailto:info@govcon-data.com" className="text-primary hover:underline">
              info@govcon-data.com
            </a>
          </p>
        </section>
      </div>
    </div>
  )
} 